// extracted by mini-css-extract-plugin
export default {"primary":"XHRM4","headerContainer":"ahVTn","composeHeaderContainer":"UMnZ2","showBorder":"mgaDV"};